module.exports = __webpack_public_path__ + "img/spider-circles-white.5cd95147.png";